import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowSplitDown: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-split-down, branch"><path d="M12 3V12L19 19" stroke="currentColor" strokeWidth="1.5"/><path d="M19.25 13V19.25H13" stroke="currentColor" strokeWidth="1.5"/><path d="M4.5 19.5L6.5 17.5" stroke="currentColor" strokeWidth="1.5"/><path d="M8 16L10 14" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconArrowSplitDown;
